// Shared icon set for the BackOffice UI. Icons are presentational
// (aria-hidden) and styled by their parent containers via CSS.

export function EyeIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M3.8 12s2.9-5.2 8.2-5.2 8.2 5.2 8.2 5.2-2.9 5.2-8.2 5.2S3.8 12 3.8 12Z" />
      <path d="M12 14.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z" />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="m19 19-4.2-4.2" />
      <circle cx="10.5" cy="10.5" r="5.5" />
    </svg>
  );
}

export function ListIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M8 7h11" />
      <path d="M8 12h11" />
      <path d="M8 17h11" />
      <path d="M4.6 7h.01" />
      <path d="M4.6 12h.01" />
      <path d="M4.6 17h.01" />
    </svg>
  );
}

export function MoonIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

export function SunIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="5" />
      <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
    </svg>
  );
}

export function PlayIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M7 5v14l11-7z" />
    </svg>
  );
}

export function PauseIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M8 5v14" />
      <path d="M16 5v14" />
    </svg>
  );
}

export function RefreshIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M17.9 8.1A7 7 0 0 0 5.8 7.4L4 9.2" />
      <path d="M4 4.8v4.4h4.4" />
      <path d="M6.1 15.9a7 7 0 0 0 12.1.7l1.8-1.8" />
      <path d="M20 19.2v-4.4h-4.4" />
    </svg>
  );
}

export function AlertIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M12 6.2v7.1" />
      <path d="M12 17.9h.01" />
    </svg>
  );
}
